import { HttpClient } from '@angular/common/http';
import {
  Component,
  EventEmitter,
  Inject,
  Input,
  OnInit,
  Output,
  SkipSelf,
} from '@angular/core';
import { ControlContainer, FormControl } from '@angular/forms';
import { Observable, debounceTime, startWith, switchMap, map } from 'rxjs';
import { MatFormFieldAppearance } from '@angular/material/form-field';
import { Retailer, Wholesaler, AppConfig } from '../../_api';
import { RestService } from '../../core/_services';
import { APP_CONFIG } from '../../core/_services/config-injection';

@Component({
  selector: 'app-retailer-wholesaler-selector',
  templateUrl: './retailer-wholesaler-selector.component.html',
  styleUrls: ['./retailer-wholesaler-selector.component.scss'],
  viewProviders: [
    {
      provide: ControlContainer,
      useFactory: (container: ControlContainer) => container,
      deps: [[new SkipSelf(), ControlContainer]],
    },
  ],
})
export class RetailerWholesalerSelectorComponent implements OnInit {
  @Input() entityType: 'Retailer' | 'Wholesaler' = 'Retailer';
  @Input() value: string;
  @Input() placeholder: string;
  @Input() labelText: string;
  @Input() required: boolean = false;
  @Output() entitySelected = new EventEmitter<Retailer | Wholesaler>();
  @Input() appearance: MatFormFieldAppearance = 'fill';

  randomString = this.getRandomString();
  entityValue: any;
  entityCtrl = new FormControl();
  filteredEntities: Observable<any>;
  entities: (Retailer | Wholesaler)[] = [];
  isLoading = false;
  lastTextTyped: string;

  constructor(
    @Inject(APP_CONFIG) public config: AppConfig,
    private http: HttpClient,
    private rest: RestService
  ) {
    this.filteredEntities = this.entityCtrl.valueChanges.pipe(
      debounceTime(200),
      startWith(''),
      switchMap((name) => {
        if (typeof name === 'string' && name !== '') {
          this.isLoading = true;
          const endpoint = `${this.entityType}/Search?pageSize=10`;

          let postData = { combinedSearch: name };

          return this.rest.postResource(endpoint, postData).pipe(
            map((response) => {
              this.isLoading = false;
              return response.results;
            })
          );
        } else {
          return [];
        }
      })
    );
  }

  ngOnInit(): void {
    this.placeholder =
      'Start typing a ' +
      this.entityType +
      ' name, trade name, CR number or address...';
  }

  private getRandomString(length: number = 5): string {
    return Math.random()
      .toString(36)
      .substring(2, 2 + length)
      .toUpperCase();
  }

  onTextChanged(e: any) {
    if (this.entityValue) this.lastTextTyped = this.entityValue;
  }

  onOptionSelected(event: any) {
    const entity = event.option.value;
    this.entitySelected.emit(entity);
  }

  displayFn(entity: any): string {
    if (!entity) return '';
    if (typeof entity === 'string') return entity;
    return entity.entityName || entity.wholesalerEntityName || '';
  }
}
